import EInvoiceConfiguration from "./EInvoiceConfiguration.vue";

export default EInvoiceConfiguration